<template>
  <div
    id="kt_quick_search"
    ref="kt_quick_search"
    class="offcanvas offcanvas-left p-10"
    style="overflow: hidden"
  >
    <!--begin::Header-->
    <div
      class="
        offcanvas-header
        d-flex
        align-items-center
        justify-content-between
        mb-5
      "
    >
      <h3 class="font-weight-bold m-0" v-if="summaryData">
        {{ summaryData.provinsi }}
        <small class="text-muted font-size-sm ml-2">Summary Data</small>
      </h3>
      <a
        href="#"
        class="btn btn-xs btn-icon btn-light btn-hover-primary"
        id="kt_quick_search_close"
      >
        <i class="ki ki-close icon-xs text-muted" />
      </a>
    </div>
    <!--end::Header-->
    <!--begin::Content-->
    <div class="offcanvas-content">
      <!--begin::Container-->
      <div class="pt-10">
        <!--begin::Capaian dosis 1-->
        <div class="card card-custom bg-light-success card-shadowless gutter-b">
          <!--begin::Body-->
          <div class="card-body my-3">
            <a
              href="#"
              class="
                card-title
                font-weight-bolder
                text-success text-hover-state-dark
                font-size-h6
                mb-4
                d-block
              "
            >
              Cakupan Dosis 1
            </a>
            <div class="font-weight-bold text-muted font-size-sm">
              <span
                class="text-dark-75 font-size-h2 font-weight-bolder mr-2"
                v-if="summaryData"
              >
                {{ dose1() }}%
              </span>
              <span v-if="summaryData">
                {{ cakupanDosis1() }}
              </span>
              Cakupan
            </div>
            <div class="progress progress-xs mt-7 bg-success-o-60">
              <div
                v-if="dose1"
                class="progress-bar bg-success"
                role="progressbar"
                :style="{
                  width: dose1() + '%',
                }"
                aria-valuenow="50"
                aria-valuemin="0"
                aria-valuemax="100"
              />
            </div>
          </div>
          <!--end:: Body-->
        </div>
        <!--end::Capaian dosis 1-->
        <!--begin::Capaian dosis 2-->
        <div class="card card-custom bg-light-warning card-shadowless gutter-b">
          <!--begin::Body-->
          <div class="card-body my-4">
            <a
              href="#"
              class="
                card-title
                font-weight-bolder
                text-warning
                font-size-h6
                mb-4
                text-hover-state-dark
                d-block
              "
            >
              Cakupan Dosis 2
            </a>
            <div class="font-weight-bold text-muted font-size-sm">
              <span
                class="text-dark-75 font-weight-bolder font-size-h2 mr-2"
                v-if="summaryData"
              >
                {{ dose2() }}%
              </span>
              <span v-if="summaryData">
                {{ cakupanDosis2() }}
              </span>
              Cakupan
            </div>
            <div class="progress progress-xs mt-7 bg-warning-o-60">
              <div
                class="progress-bar bg-warning"
                role="progressbar"
                :style="{
                  width: dose2() + '%',
                }"
                aria-valuenow="50"
                aria-valuemin="0"
                aria-valuemax="100"
              />
            </div>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Capaian dosis 2-->
        <!--begin::Region melapor-->
        <div class="card card-custom card-shadowless gutter-b bg-light">
          <!--begin::Body-->
          <div class="card-body my-4">
            <a
              href="#"
              class="
                card-title
                font-weight-bolder
                text-dark
                font-size-h6
                mb-4
                text-hover-state-dark
                d-block
              "
            >
              KaKo Melapor
            </a>
            <div class="font-weight-bold text-muted font-size-sm">
              <span
                class="text-dark-75 font-weight-bolder font-size-h2 mr-2"
                v-if="summaryData"
              >
                {{ regionReport() }}%
              </span>
              <span v-if="summaryData">
                {{ cakupanRegionReport() }}
              </span>
              KaKo melapor
            </div>
            <div class="progress progress-xs mt-7 bg-dark-o-60">
              <div
                class="progress-bar bg-dark"
                role="progressbar"
                :style="{
                  width: regionReport() + '%',
                }"
                aria-valuenow="50"
                aria-valuemin="0"
                aria-valuemax="100"
              />
            </div>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Region melapor-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::Content-->
  </div>
</template>

<style lang="scss" scoped>
#kt_quick_user {
  overflow: hidden;
}
</style>

<script>
import KTLayoutQuickSearch from '@/assets/js/layout/extended/quick-search.js'
import KTOffcanvas from '@/assets/js/components/offcanvas.js'
import { addDots } from '@/core/helpers/temp/util.js'

export default {
  name: 'KTQuickSearch',
  props: {
    summaryData: Object,
  },
  mounted() {
    // Init Quick User Panel
    KTLayoutQuickSearch.init(this.$refs['kt_quick_search'])
  },
  methods: {
    closeOffcanvas() {
      new KTOffcanvas(KTLayoutQuickSearch.getElement()).hide()
    },

    cakupanDosis1() {
      return addDots(this.summaryData.capaian_harian_dosis_1)
    },
    dose1() {
      return this.summaryData
        ? this.summaryData.persentase_capaian_harian_dosis_1
        : null
    },
    cakupanDosis2() {
      return addDots(this.summaryData.capaian_harian_dosis_2)
    },
    dose2() {
      return this.summaryData
        ? this.summaryData.persentase_capaian_harian_dosis_2
        : null
    },
    regionReport() {
      return this.summaryData
        ? this.summaryData.persentase_region_melapor
        : null
    },
    cakupanRegionReport() {
      return this.summaryData ? this.summaryData.jumlah_region_melapor : null
    },
  },
}
</script>
